import React from 'react'
import { useParams } from 'react-router-dom'
import { Titulo } from 'asocomponents'
import GrillaAdjuntoJuicio from '../../moleculas/GrillaAdjuntos/GrillaAdjuntoJuicio'

export default function GrillaAdjuntoJuicioContainer() {

    const idJuicio = useParams().idJuicio

    return (
        <div>
            <div>            
                <Titulo titulo="Documentos Digitalizados Juicio" />
            </div>
            <div className='mt-5'>
                <GrillaAdjuntoJuicio idJuicio={idJuicio} />
            </div>
        </div>
    )
}
